import { useState } from 'react';
import type { PlatformInvoicePrint } from '../../services/billingService';
import { usePdfExport } from '../../utils/pdf';
import PlatformInvoiceDocument from './pdf/PlatformInvoiceDocument';

/**
 * Subscription invoices drawn in the browser — the school's Billing page and
 * the platform admin's Subscriptions page. `busyId` is the payment whose
 * invoice is being drawn, for its button's spinner.
 */
export function usePlatformInvoicePdf() {
  const { generate } = usePdfExport();
  const [busyId, setBusyId] = useState<string | null>(null);

  const download = async (paymentId: string, invoiceNumber: string, load: () => Promise<PlatformInvoicePrint>) => {
    setBusyId(paymentId);
    try {
      await generate(async () => <PlatformInvoiceDocument invoice={await load()} generatedAt={new Date().toISOString()} />, `${invoiceNumber}.pdf`);
    } finally {
      setBusyId(null);
    }
  };

  return { download, busyId };
}
